export default class Routes {
  public static readonly links = [
    { href: "/episodes", title: "Episodes" },
    { href: "/contact", title: "Contact Us" },
  ];
}

export type Route = (typeof Routes.links)[number];
